// ---------------------------------------------------------------------------
// Shared formatting utilities for the Djayma admin panel.
// All FCFA display formatting goes through here — no copy-pasting.
// ---------------------------------------------------------------------------

const fcfaFormatter = new Intl.NumberFormat("fr-FR", {
  style: "decimal",
  maximumFractionDigits: 0,
});

const numberFormatter = new Intl.NumberFormat("fr-FR", {
  style: "decimal",
  maximumFractionDigits: 0,
});

/**
 * Format an amount as FCFA for display (e.g. "1 500 000 FCFA").
 * For financial *calculations*, use decimal.js — this is display-only.
 */
export function formatFcfa(amount: number): string {
  return fcfaFormatter.format(amount) + " FCFA";
}

/**
 * Variant that handles nullable amounts (common in API responses).
 */
export function formatFcfaOrDash(amount: number | null | undefined): string {
  if (amount == null) return "—";
  return formatFcfa(amount);
}

/**
 * Format a plain number with locale grouping (e.g. "1 500").
 */
export function formatNumber(value: number): string {
  return numberFormatter.format(value);
}

/**
 * Format a rate/percentage for display (e.g. "42,5 %").
 */
export function formatRate(value: number, decimals = 1): string {
  return `${value.toFixed(decimals).replace(".", ",")} %`;
}
